<script>
// Imports individuais em vez de 'import * as icons' — o import total puxava
// TODOS os +280 ícones do pacote para o bundle inicial (este componente é
// registrado globalmente). A lista abaixo é gerada a partir dos nomes usados
// no código; ícone novo => adicionar o import aqui (em dev, ícone ausente
// loga um aviso no console e renderiza um círculo como fallback).
import ActivityIcon from 'vue-feather-icons/icons/ActivityIcon'
import AlertCircleIcon from 'vue-feather-icons/icons/AlertCircleIcon'
import AlertOctagonIcon from 'vue-feather-icons/icons/AlertOctagonIcon'
import AlertTriangleIcon from 'vue-feather-icons/icons/AlertTriangleIcon'
import AlignCenterIcon from 'vue-feather-icons/icons/AlignCenterIcon'
import ArchiveIcon from 'vue-feather-icons/icons/ArchiveIcon'
import ArrowDownCircleIcon from 'vue-feather-icons/icons/ArrowDownCircleIcon'
import ArrowDownIcon from 'vue-feather-icons/icons/ArrowDownIcon'
import ArrowDownLeftIcon from 'vue-feather-icons/icons/ArrowDownLeftIcon'
import ArrowLeftIcon from 'vue-feather-icons/icons/ArrowLeftIcon'
import ArrowRightIcon from 'vue-feather-icons/icons/ArrowRightIcon'
import ArrowUpCircleIcon from 'vue-feather-icons/icons/ArrowUpCircleIcon'
import ArrowUpIcon from 'vue-feather-icons/icons/ArrowUpIcon'
import ArrowUpRightIcon from 'vue-feather-icons/icons/ArrowUpRightIcon'
import AwardIcon from 'vue-feather-icons/icons/AwardIcon'
import BarChart2Icon from 'vue-feather-icons/icons/BarChart2Icon'
import BarChartIcon from 'vue-feather-icons/icons/BarChartIcon'
import BellIcon from 'vue-feather-icons/icons/BellIcon'
import BellOffIcon from 'vue-feather-icons/icons/BellOffIcon'
import BookIcon from 'vue-feather-icons/icons/BookIcon'
import BookOpenIcon from 'vue-feather-icons/icons/BookOpenIcon'
import BriefcaseIcon from 'vue-feather-icons/icons/BriefcaseIcon'
import CalendarIcon from 'vue-feather-icons/icons/CalendarIcon'
import CameraIcon from 'vue-feather-icons/icons/CameraIcon'
import CastIcon from 'vue-feather-icons/icons/CastIcon'
import CheckCircleIcon from 'vue-feather-icons/icons/CheckCircleIcon'
import CheckIcon from 'vue-feather-icons/icons/CheckIcon'
import CheckSquareIcon from 'vue-feather-icons/icons/CheckSquareIcon'
import ChevronDownIcon from 'vue-feather-icons/icons/ChevronDownIcon'
import ChevronLeftIcon from 'vue-feather-icons/icons/ChevronLeftIcon'
import ChevronRightIcon from 'vue-feather-icons/icons/ChevronRightIcon'
import ChevronUpIcon from 'vue-feather-icons/icons/ChevronUpIcon'
import CircleIcon from 'vue-feather-icons/icons/CircleIcon'
import ClipboardIcon from 'vue-feather-icons/icons/ClipboardIcon'
import ClockIcon from 'vue-feather-icons/icons/ClockIcon'
import CodeIcon from 'vue-feather-icons/icons/CodeIcon'
import CoffeeIcon from 'vue-feather-icons/icons/CoffeeIcon'
import ColumnsIcon from 'vue-feather-icons/icons/ColumnsIcon'
import CopyIcon from 'vue-feather-icons/icons/CopyIcon'
import CornerDownLeftIcon from 'vue-feather-icons/icons/CornerDownLeftIcon'
import CornerUpLeftIcon from 'vue-feather-icons/icons/CornerUpLeftIcon'
import CpuIcon from 'vue-feather-icons/icons/CpuIcon'
import CreditCardIcon from 'vue-feather-icons/icons/CreditCardIcon'
import CropIcon from 'vue-feather-icons/icons/CropIcon'
import DatabaseIcon from 'vue-feather-icons/icons/DatabaseIcon'
import DiscIcon from 'vue-feather-icons/icons/DiscIcon'
import DollarSignIcon from 'vue-feather-icons/icons/DollarSignIcon'
import DownloadCloudIcon from 'vue-feather-icons/icons/DownloadCloudIcon'
import DownloadIcon from 'vue-feather-icons/icons/DownloadIcon'
import DropletIcon from 'vue-feather-icons/icons/DropletIcon'
import Edit3Icon from 'vue-feather-icons/icons/Edit3Icon'
import EditIcon from 'vue-feather-icons/icons/EditIcon'
import ExternalLinkIcon from 'vue-feather-icons/icons/ExternalLinkIcon'
import EyeIcon from 'vue-feather-icons/icons/EyeIcon'
import EyeOffIcon from 'vue-feather-icons/icons/EyeOffIcon'
import FacebookIcon from 'vue-feather-icons/icons/FacebookIcon'
import FeatherIcon from 'vue-feather-icons/icons/FeatherIcon'
import FileIcon from 'vue-feather-icons/icons/FileIcon'
import FilePlusIcon from 'vue-feather-icons/icons/FilePlusIcon'
import FileTextIcon from 'vue-feather-icons/icons/FileTextIcon'
import FilterIcon from 'vue-feather-icons/icons/FilterIcon'
import FolderIcon from 'vue-feather-icons/icons/FolderIcon'
import GiftIcon from 'vue-feather-icons/icons/GiftIcon'
import GitBranchIcon from 'vue-feather-icons/icons/GitBranchIcon'
import GitCommitIcon from 'vue-feather-icons/icons/GitCommitIcon'
import GitMergeIcon from 'vue-feather-icons/icons/GitMergeIcon'
import GlobeIcon from 'vue-feather-icons/icons/GlobeIcon'
import GridIcon from 'vue-feather-icons/icons/GridIcon'
import HashIcon from 'vue-feather-icons/icons/HashIcon'
import HeadphonesIcon from 'vue-feather-icons/icons/HeadphonesIcon'
import HeartIcon from 'vue-feather-icons/icons/HeartIcon'
import HelpCircleIcon from 'vue-feather-icons/icons/HelpCircleIcon'
import HomeIcon from 'vue-feather-icons/icons/HomeIcon'
import ImageIcon from 'vue-feather-icons/icons/ImageIcon'
import InboxIcon from 'vue-feather-icons/icons/InboxIcon'
import InfoIcon from 'vue-feather-icons/icons/InfoIcon'
import InstagramIcon from 'vue-feather-icons/icons/InstagramIcon'
import KeyIcon from 'vue-feather-icons/icons/KeyIcon'
import LayersIcon from 'vue-feather-icons/icons/LayersIcon'
import LinkIcon from 'vue-feather-icons/icons/LinkIcon'
import LinkedinIcon from 'vue-feather-icons/icons/LinkedinIcon'
import ListIcon from 'vue-feather-icons/icons/ListIcon'
import LockIcon from 'vue-feather-icons/icons/LockIcon'
import LogInIcon from 'vue-feather-icons/icons/LogInIcon'
import LogOutIcon from 'vue-feather-icons/icons/LogOutIcon'
import MailIcon from 'vue-feather-icons/icons/MailIcon'
import MapIcon from 'vue-feather-icons/icons/MapIcon'
import MapPinIcon from 'vue-feather-icons/icons/MapPinIcon'
import MenuIcon from 'vue-feather-icons/icons/MenuIcon'
import MessageCircleIcon from 'vue-feather-icons/icons/MessageCircleIcon'
import MessageSquareIcon from 'vue-feather-icons/icons/MessageSquareIcon'
import MinusIcon from 'vue-feather-icons/icons/MinusIcon'
import MonitorIcon from 'vue-feather-icons/icons/MonitorIcon'
import MoonIcon from 'vue-feather-icons/icons/MoonIcon'
import MoreHorizontalIcon from 'vue-feather-icons/icons/MoreHorizontalIcon'
import MoveIcon from 'vue-feather-icons/icons/MoveIcon'
import PackageIcon from 'vue-feather-icons/icons/PackageIcon'
import PaperclipIcon from 'vue-feather-icons/icons/PaperclipIcon'
import PauseCircleIcon from 'vue-feather-icons/icons/PauseCircleIcon'
import PercentIcon from 'vue-feather-icons/icons/PercentIcon'
import PhoneCallIcon from 'vue-feather-icons/icons/PhoneCallIcon'
import PhoneIcon from 'vue-feather-icons/icons/PhoneIcon'
import PhoneOffIcon from 'vue-feather-icons/icons/PhoneOffIcon'
import PieChartIcon from 'vue-feather-icons/icons/PieChartIcon'
import PlayCircleIcon from 'vue-feather-icons/icons/PlayCircleIcon'
import PlayIcon from 'vue-feather-icons/icons/PlayIcon'
import PlusCircleIcon from 'vue-feather-icons/icons/PlusCircleIcon'
import PlusIcon from 'vue-feather-icons/icons/PlusIcon'
import PlusSquareIcon from 'vue-feather-icons/icons/PlusSquareIcon'
import PrinterIcon from 'vue-feather-icons/icons/PrinterIcon'
import RefreshCcwIcon from 'vue-feather-icons/icons/RefreshCcwIcon'
import RefreshCwIcon from 'vue-feather-icons/icons/RefreshCwIcon'
import RepeatIcon from 'vue-feather-icons/icons/RepeatIcon'
import RotateCcwIcon from 'vue-feather-icons/icons/RotateCcwIcon'
import RotateCwIcon from 'vue-feather-icons/icons/RotateCwIcon'
import SaveIcon from 'vue-feather-icons/icons/SaveIcon'
import SearchIcon from 'vue-feather-icons/icons/SearchIcon'
import SendIcon from 'vue-feather-icons/icons/SendIcon'
import ServerIcon from 'vue-feather-icons/icons/ServerIcon'
import SettingsIcon from 'vue-feather-icons/icons/SettingsIcon'
import Share2Icon from 'vue-feather-icons/icons/Share2Icon'
import ShareIcon from 'vue-feather-icons/icons/ShareIcon'
import ShieldIcon from 'vue-feather-icons/icons/ShieldIcon'
import ShoppingBagIcon from 'vue-feather-icons/icons/ShoppingBagIcon'
import ShoppingCartIcon from 'vue-feather-icons/icons/ShoppingCartIcon'
import ShuffleIcon from 'vue-feather-icons/icons/ShuffleIcon'
import SlashIcon from 'vue-feather-icons/icons/SlashIcon'
import SlidersIcon from 'vue-feather-icons/icons/SlidersIcon'
import SmartphoneIcon from 'vue-feather-icons/icons/SmartphoneIcon'
import SquareIcon from 'vue-feather-icons/icons/SquareIcon'
import StarIcon from 'vue-feather-icons/icons/StarIcon'
import StopCircleIcon from 'vue-feather-icons/icons/StopCircleIcon'
import SunIcon from 'vue-feather-icons/icons/SunIcon'
import SunriseIcon from 'vue-feather-icons/icons/SunriseIcon'
import SunsetIcon from 'vue-feather-icons/icons/SunsetIcon'
import TagIcon from 'vue-feather-icons/icons/TagIcon'
import TargetIcon from 'vue-feather-icons/icons/TargetIcon'
import ThumbsDownIcon from 'vue-feather-icons/icons/ThumbsDownIcon'
import ThumbsUpIcon from 'vue-feather-icons/icons/ThumbsUpIcon'
import ToolIcon from 'vue-feather-icons/icons/ToolIcon'
import Trash2Icon from 'vue-feather-icons/icons/Trash2Icon'
import TrashIcon from 'vue-feather-icons/icons/TrashIcon'
import TrendingDownIcon from 'vue-feather-icons/icons/TrendingDownIcon'
import TrendingUpIcon from 'vue-feather-icons/icons/TrendingUpIcon'
import TruckIcon from 'vue-feather-icons/icons/TruckIcon'
import UnlockIcon from 'vue-feather-icons/icons/UnlockIcon'
import UploadCloudIcon from 'vue-feather-icons/icons/UploadCloudIcon'
import UploadIcon from 'vue-feather-icons/icons/UploadIcon'
import UserIcon from 'vue-feather-icons/icons/UserIcon'
import UserMinusIcon from 'vue-feather-icons/icons/UserMinusIcon'
import UserPlusIcon from 'vue-feather-icons/icons/UserPlusIcon'
import UserXIcon from 'vue-feather-icons/icons/UserXIcon'
import UsersIcon from 'vue-feather-icons/icons/UsersIcon'
import VideoIcon from 'vue-feather-icons/icons/VideoIcon'
import WifiOffIcon from 'vue-feather-icons/icons/WifiOffIcon'
import XCircleIcon from 'vue-feather-icons/icons/XCircleIcon'
import XIcon from 'vue-feather-icons/icons/XIcon'
import XOctagonIcon from 'vue-feather-icons/icons/XOctagonIcon'
import YoutubeIcon from 'vue-feather-icons/icons/YoutubeIcon'
import ZapIcon from 'vue-feather-icons/icons/ZapIcon'
import ZoomInIcon from 'vue-feather-icons/icons/ZoomInIcon'
import ZoomOutIcon from 'vue-feather-icons/icons/ZoomOutIcon'

const icons = {
  ActivityIcon,
  AlertCircleIcon,
  AlertOctagonIcon,
  AlertTriangleIcon,
  AlignCenterIcon,
  ArchiveIcon,
  ArrowDownCircleIcon,
  ArrowDownIcon,
  ArrowDownLeftIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpCircleIcon,
  ArrowUpIcon,
  ArrowUpRightIcon,
  AwardIcon,
  BarChart2Icon,
  BarChartIcon,
  BellIcon,
  BellOffIcon,
  BookIcon,
  BookOpenIcon,
  BriefcaseIcon,
  CalendarIcon,
  CameraIcon,
  CastIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CircleIcon,
  ClipboardIcon,
  ClockIcon,
  CodeIcon,
  CoffeeIcon,
  ColumnsIcon,
  CopyIcon,
  CornerDownLeftIcon,
  CornerUpLeftIcon,
  CpuIcon,
  CreditCardIcon,
  CropIcon,
  DatabaseIcon,
  DiscIcon,
  DollarSignIcon,
  DownloadCloudIcon,
  DownloadIcon,
  DropletIcon,
  Edit3Icon,
  EditIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FeatherIcon,
  FileIcon,
  FilePlusIcon,
  FileTextIcon,
  FilterIcon,
  FolderIcon,
  GiftIcon,
  GitBranchIcon,
  GitCommitIcon,
  GitMergeIcon,
  GlobeIcon,
  GridIcon,
  HashIcon,
  HeadphonesIcon,
  HeartIcon,
  HelpCircleIcon,
  HomeIcon,
  ImageIcon,
  InboxIcon,
  InfoIcon,
  InstagramIcon,
  KeyIcon,
  LayersIcon,
  LinkIcon,
  LinkedinIcon,
  ListIcon,
  LockIcon,
  LogInIcon,
  LogOutIcon,
  MailIcon,
  MapIcon,
  MapPinIcon,
  MenuIcon,
  MessageCircleIcon,
  MessageSquareIcon,
  MinusIcon,
  MonitorIcon,
  MoonIcon,
  MoreHorizontalIcon,
  MoveIcon,
  PackageIcon,
  PaperclipIcon,
  PauseCircleIcon,
  PercentIcon,
  PhoneCallIcon,
  PhoneIcon,
  PhoneOffIcon,
  PieChartIcon,
  PlayCircleIcon,
  PlayIcon,
  PlusCircleIcon,
  PlusIcon,
  PlusSquareIcon,
  PrinterIcon,
  RefreshCcwIcon,
  RefreshCwIcon,
  RepeatIcon,
  RotateCcwIcon,
  RotateCwIcon,
  SaveIcon,
  SearchIcon,
  SendIcon,
  ServerIcon,
  SettingsIcon,
  Share2Icon,
  ShareIcon,
  ShieldIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  ShuffleIcon,
  SlashIcon,
  SlidersIcon,
  SmartphoneIcon,
  SquareIcon,
  StarIcon,
  StopCircleIcon,
  SunIcon,
  SunriseIcon,
  SunsetIcon,
  TagIcon,
  TargetIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  ToolIcon,
  Trash2Icon,
  TrashIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  TruckIcon,
  UnlockIcon,
  UploadCloudIcon,
  UploadIcon,
  UserIcon,
  UserMinusIcon,
  UserPlusIcon,
  UserXIcon,
  UsersIcon,
  VideoIcon,
  WifiOffIcon,
  XCircleIcon,
  XIcon,
  XOctagonIcon,
  YoutubeIcon,
  ZapIcon,
  ZoomInIcon,
  ZoomOutIcon,
}

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
  },
  render(h, { props, data }) {
    let iconComponent = typeof props.icon === 'string' ? icons[props.icon] : props.icon
    if (!iconComponent) {
      // eslint-disable-next-line no-console
      console.warn(`[FeatherIcon] Ícone "${props.icon}" não está na lista de imports de FeatherIcon.vue`)
      iconComponent = icons.CircleIcon
    }

    // Create Feather Icon
    const svg = h(iconComponent, { props: { size: props.size }, ...data })

    // If no badge is provided => Render just SVG
    if (!props.badge) return svg

    // Badge
    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses }, [props.badge])

    // Return span with children
    return h('span', { staticClass: 'feather-icon position-relative' }, [svg, badgeEl])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}
</style>
